import { render, staticRenderFns } from "./SellerCurrencyConfigDialog.vue?vue&type=template&id=6a4a310b&scoped=true"
import script from "./SellerCurrencyConfigDialog.vue?vue&type=script&lang=js"
export * from "./SellerCurrencyConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./SellerCurrencyConfigDialog.vue?vue&type=style&index=0&id=6a4a310b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a310b",
  null
  
)

export default component.exports